// The New Appraisal Experience is served by IntegratedAppraisalEdit.aspx. The
// shared appraisal URL from config points at the legacy Default.aspx page (used
// by the open-in-new-tab flows), so for the iframe we swap the final path
// segment to the integrated page, keeping the same host and query-param contract.
const INTEGRATED_APPRAISAL_PAGE = 'IntegratedAppraisalEdit.aspx';

export const toIntegratedAppraisalUrl = (url: string): string => {
    try {
        const parsed = new URL(url);
        parsed.pathname = parsed.pathname.replace(/[^/]*$/, INTEGRATED_APPRAISAL_PAGE);
        return `${parsed.origin}${parsed.pathname}`;
    } catch {
        return url;
    }
};

// vAuto posts its save/finalize message to the top window. When Dash is the top
// frame this is just `window`; when Dash is nested we attach to the top window
// so we still receive the message. If the top window is cross-origin we cannot
// touch it, so we fall back to the current window.
export const getPostMessageTarget = (): Window => {
    const topWindow = window.top;
    if (!topWindow || topWindow === window) {
        return window;
    }
    try {
        // Reading a property of a cross-origin window throws; if it succeeds the
        // top window is same-origin and safe to attach a listener to.
        void topWindow.origin;
        return topWindow;
    } catch {
        return window;
    }
};
